<div class="mwp-modal">
    <div class="header">
        <mwp-text-translate text="Change Password" jsonKey="changePassword" />
    </div>
    <div class="body">
        <mwp-password [isDialogBox]="true" [displayHeader]="false" (emitComplete)="close()" />
    </div>
    <div class="footer pt-0">
        <button class="mwp-button-secondary w-100" (click)="close()">
            <mwp-text-translate text="CANCEL" jsonKey="cancel" />
        </button>
    </div>
</div>